module.exports = __webpack_public_path__ + "img/newest.43c219c1.png";